import { compose } from 'recompose';

import TaskItem from './taskItem';

const enhance = compose();
export default enhance(TaskItem);
